import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import InvoiceTable from "./InvoiceTable";
import AddInvoice from "./AddInvoice";
import styles from "./InvoiceProcess.module.css";
import { useSelector } from "react-redux";

const InvoiceProcess = () => {
  const [view, setView] = useState("LIST");
  const [vendorInvoices, setVendorInvoices] = useState([]);
  const loginData = useSelector((state) => state.loginData.value);
  const VendorToken = loginData?.user?.user_token;
  console.log(VendorToken);
  const handleSaveInvoice = (invoice) => {
    setVendorInvoices((prev) => [
      ...prev,
      {
        id: Date.now(),
        created_at: new Date().toLocaleString(),
        ...invoice,
      },
    ]);
    setView("LIST");
  };

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action } = JSON.parse(chatActionRaw);

    if (action === "add_invoice") {
      setView("ADD");
      // sessionStorage.removeItem("CHAT_ACTION");
    }
  }, []);

  return (
    <Box className={styles.container}>
      {view === "LIST" && (
        <>
          {/* HEADER */}
          <Box className={styles.header}>
            <h1 className={styles.pageTitle}>Invoice Process</h1>
            <Button
              size="large"
              variant="contained"
              onClick={() => setView("ADD")}
              sx={{ fontSize: "12px" }}
            >
              Add Invoice
            </Button>
          </Box>

          {/* TABLE */}
          <InvoiceTable data={vendorInvoices} VendorToken={VendorToken} />
        </>
      )}

      {view === "ADD" && (
        <AddInvoice
          onCancel={() => setView("LIST")}
          onSave={handleSaveInvoice}
          VendorToken={VendorToken}
        />
      )}
    </Box>
  );
};

export default InvoiceProcess;
